{
  "$schema": "http://json.schemastore.org/package",
  "name": "verdaccio-passport-google-oauth-ui",
  "version": "0.1.9",
  "keywords": [
    "authentication",
    "google",
    "login",
    "npm",
    "oauth",
    "package",
    "passport",
    "private",
    "registry",
    "verdaccio",
    "verdaccio-auth",
    "verdaccio-auth-plugin",
    "verdaccio-plugin"
  ],
  "bugs": "https://github.com/okayasu/verdaccio-passport-google-oauth-ui/issues",
  "repository": "github:okayasu/verdaccio-passport-google-oauth-ui",
  "license": "MIT",
  "author": "Masanori Okayasu",
  "main": "dist/server/index.js",
  "bin": "dist/cli/index.js",
  "files": [
    "dist",
    "verdaccio.yaml"
  ],
  "scripts": {
    "build": "bash run build",
    "clean": "bash run clean",
    "cli": "bash run cli",
    "cli:login": "bash run cli-login",
    "cli:publish": "bash run cli-publish",
    "cli:whoami": "bash run cli-whoami",
    "copy": "bash run copy",
    "coverage": "vitest --coverage",
    "dev": "yarn update && yarn start",
    "docker": "bash run docker_",
    "fix": "yarn format && yarn typecheck",
    "format": "prettier --write \"**/*.{ts,js,css,scss,html,json}\"",
    "format:check": "prettier --check \"**/*.{ts,js,css,scss,html,json}\"",
    "prepack": "bash run clean && bash run build",
    "start": "verdaccio -c verdaccio.yaml",
    "test": "vitest",
    "typecheck": "bash run typecheck",
    "update": "yarn prepack && yarn copy",
    "watch": "nodemon --watch src --watch verdaccio.yaml --ext ts,css,yaml --exec \"yarn dev\""
  },
  "dependencies": {
    "@verdaccio/url": "^11.0.0-6-next.42",
    "copy-to-clipboard": "^3.3.3",
    "dotenv": "^17.2.2",
    "express": "^5.1.0",
    "global-agent": "^3.0.0",
    "lodash": "^4.17.21",
    "minimist": "^1.2.8",
    "open": "^10.2.0",
    "ow": "^2.0.0",
    "passport": "^0.7.0",
    "passport-google-oauth": "^2.0.0",
    "picocolors": "^1.1.1"
  },
  "devDependencies": {
    "@parcel/config-default": "^2.15.4",
    "@parcel/transformer-typescript-tsc": "^2.15.4",
    "@types/express": "^5.0.3",
    "@types/global-agent": "^3.0.0",
    "@types/lodash": "^4.17.20",
    "@types/minimist": "^1.2.5",
    "@types/node": "^24.3.0",
    "@types/passport": "^1.0.17",
    "@types/passport-google-oauth": "^1.0.45",
    "@verdaccio/types": "^10.8.0",
    "@vitest/coverage-v8": "^3.2.4",
    "browserslist": "^4.27.0",
    "core-js": "^3.46.0",
    "nodemon": "^3.1.10",
    "parcel": "^2.15.4",
    "prettier": "^3.6.2",
    "process": "^0.11.10",
    "timekeeper": "^2.3.1",
    "type-fest": "^4.41.0",
    "typescript": "^5.9.3",
    "verdaccio": "~6.1.6",
    "verdaccio-htpasswd": "^10.5.5",
    "vitest": "^3.2.4"
  },
  "peerDependencies": {
    "verdaccio": ">=5"
  },
  "packageManager": "yarn@4.8.1",
  "publishConfig": {
    "registry": "https://registry.npmjs.org/"
  },
  "targets": {
    "client": {
      "source": "src/client/verdaccio-5.ts",
      "distDir": "dist/client",
      "context": "browser",
      "includeNodeModules": true
    },
    "server": {
      "source": "src/server/index.ts",
      "distDir": "dist/server",
      "context": "node",
      "outputFormat": "commonjs",
      "optimize": false,
      "isLibrary": true
    },
    "cli": {
      "source": "src/cli/index.ts",
      "distDir": "dist/cli",
      "context": "node",
      "outputFormat": "commonjs",
      "optimize": false
    }
  }
}
